import MainNavbar from './MainNavbar';
import SecondaryNavbar from './SecondaryNavbar';
import DemoModeNavbar from './DemoModeNavbar';
import Config from '../config/Config';

const Navigation = ({ toggleLanguage, currentLanguage }) => (
  <>
    {Config.isDemo === 'true' && <DemoModeNavbar />}
    <MainNavbar toggleLanguage={toggleLanguage} currentLanguage={currentLanguage} />
    <SecondaryNavbar />
  </>
);

export default Navigation;
